import { useTranslation } from "react-i18next";
import Text_de from "../../images/Login/IS_smartTITAN_Login-Registrieren_2_DE.png";
import Text_en from "../../images/Login/IS_smartTITAN_Login-Registrieren_2_EN.png";
import Text_es from "../../images/Login/IS_smartTITAN_Login-Registrieren_2_ES.png";
import "./MobileWarning.scss";
import { useDispatch, useSelector } from "react-redux";
import { selectIgnoreMobile, setIgnoreMobile } from "../../store/slices/appTitanSlice";
import titanLogo from "../../images/Ischebeck_Logo2013_VarA_RGB_1zu1_trans.svg";

function MobileWarning() {
  const { i18n, t } = useTranslation("translation");
  const ignoreMobile = useSelector(selectIgnoreMobile);
  const dispatch = useDispatch();

  function handleOnClick() {
    dispatch(setIgnoreMobile(!ignoreMobile));
  }

  return (
    <section className="mobileWarning grid">
      <div className="container-fluid h-100 p-0">
        <div className="mobileWarning-main-image-container">
          <img
            className="mobileWarning-main-image img-fluid"
            src={
              i18n.language === "en"
                ? Text_en
                : i18n.language === "de-DE"
                  ? Text_de
                  : i18n.language === "es-ES"
                    ? Text_es
                    : Text_en
            }
            alt=""
            onClick={() => handleOnClick()}
          />
          <div className="mobileWarning-logo-wrapper">
            <img className="login-top-logo" src={titanLogo} alt="" />
          </div>
        </div>

        <p className="text">{t("mobileWarning.text")}</p>
      </div>
    </section>
  );
}

export default MobileWarning;
